export enum ListType {
  NO_RESTRICTIONS = 'no restrictions',
  ALLOW_LIST = 'allowed',
  BLOCK_LIST = 'blocked',
}

export const HNISO3166Alpha3CountryNames: Record<string, string> = {
  AFG: 'Afghanistan',
  ALA: 'Åland Islands',
  ALB: 'Albania',
  DZA: 'Algeria',
  ASM: 'American Samoa',
  AND: 'Andorra',
  AGO: 'Angola',
  AIA: 'Anguilla',
  ATA: 'Antarctica',
  ATG: 'Antigua and Barbuda',
  ARG: 'Argentina',
  ARM: 'Armenia',
  ABW: 'Aruba',
  AUS: 'Australia',
  AUT: 'Austria',
  AZE: 'Azerbaijan',
  BHS: 'Bahamas',
  BHR: 'Bahrain',
  BGD: 'Bangladesh',
  BRB: 'Barbados',
  BLR: 'Belarus',
  BEL: 'Belgium',
  BLZ: 'Belize',
  BEN: 'Benin',
  BMU: 'Bermuda',
  BTN: 'Bhutan',
  BOL: 'Bolivia',
  BES: 'Caribbean Netherlands',
  BIH: 'Bosnia and Herzegovina',
  BWA: 'Botswana',
  BVT: 'Bouvet Island',
  BRA: 'Brazil',
  IOT: 'British Indian Ocean Territory',
  BRN: 'Brunei Darussalam',
  BGR: 'Bulgaria',
  BFA: 'Burkina Faso',
  BDI: 'Burundi',
  CPV: 'Cabo Verde',
  KHM: 'Cambodia',
  CMR: 'Cameroon',
  CAN: 'Canada',
  CYM: 'Cayman Islands',
  CAF: 'Central African Republic',
  TCD: 'Chad',
  CHL: 'Chile',
  CHN: 'China',
  CXR: 'Christmas Island',
  CCK: 'Cocos (Keeling) Islands',
  COL: 'Colombia',
  COM: 'Comoros',
  COG: 'Congo',
  COD: 'Congo, Democratic Republic of the',
  COK: 'Cook Islands',
  CRI: 'Costa Rica',
  CIV: "Côte d'Ivoire",
  HRV: 'Croatia',
  CUB: 'Cuba',
  CUW: 'Curaçao',
  CYP: 'Cyprus',
  CZE: 'Czechia',
  DNK: 'Denmark',
  DJI: 'Djibouti',
  DMA: 'Dominica',
  DOM: 'Dominican Republic',
  ECU: 'Ecuador',
  EGY: 'Egypt',
  SLV: 'El Salvador',
  GNQ: 'Equatorial Guinea',
  ERI: 'Eritrea',
  EST: 'Estonia',
  SWZ: 'Eswatini',
  ETH: 'Ethiopia',
  FLK: 'Falkland Islands',
  FRO: 'Faroe Islands',
  FJI: 'Fiji',
  FIN: 'Finland',
  FRA: 'France',
  GUF: 'French Guiana',
  PYF: 'French Polynesia',
  ATF: 'French Southern Territories',
  GAB: 'Gabon',
  GMB: 'Gambia',
  GEO: 'Georgia',
  DEU: 'Germany',
  GHA: 'Ghana',
  GIB: 'Gibraltar',
  GRC: 'Greece',
  GRL: 'Greenland',
  GRD: 'Grenada',
  GLP: 'Guadeloupe',
  GUM: 'Guam',
  GTM: 'Guatemala',
  GGY: 'Guernsey',
  GIN: 'Guinea',
  GNB: 'Guinea-Bissau',
  GUY: 'Guyana',
  HTI: 'Haiti',
  HMD: 'Heard Island and McDonald Islands',
  VAT: 'Holy See',
  HND: 'Honduras',
  HKG: 'Hong Kong',
  HUN: 'Hungary',
  ISL: 'Iceland',
  IND: 'India',
  IDN: 'Indonesia',
  IRN: 'Iran',
  IRQ: 'Iraq',
  IRL: 'Ireland',
  IMN: 'Isle of Man',
  ISR: 'Israel',
  ITA: 'Italy',
  JAM: 'Jamaica',
  JPN: 'Japan',
  JEY: 'Jersey',
  JOR: 'Jordan',
  KAZ: 'Kazakhstan',
  KEN: 'Kenya',
  KIR: 'Kiribati',
  PRK: 'North Korea',
  KOR: 'South Korea',
  QZZ: 'Unknown Country',
  KWT: 'Kuwait',
  KGZ: 'Kyrgyzstan',
  LAO: 'Laos',
  LVA: 'Latvia',
  LBN: 'Lebanon',
  LSO: 'Lesotho',
  LBR: 'Liberia',
  LBY: 'Libya',
  LIE: 'Liechtenstein',
  LTU: 'Lithuania',
  LUX: 'Luxembourg',
  MAC: 'Macao',
  MDG: 'Madagascar',
  MWI: 'Malawi',
  MYS: 'Malaysia',
  MDV: 'Maldives',
  MLI: 'Mali',
  MLT: 'Malta',
  MHL: 'Marshall Islands',
  MTQ: 'Martinique',
  MRT: 'Mauritania',
  MUS: 'Mauritius',
  MYT: 'Mayotte',
  MEX: 'Mexico',
  FSM: 'Micronesia',
  MDA: 'Moldova',
  MCO: 'Monaco',
  MNG: 'Mongolia',
  MNE: 'Montenegro',
  MSR: 'Montserrat',
  MAR: 'Morocco',
  MOZ: 'Mozambique',
  MMR: 'Myanmar',
  NAM: 'Namibia',
  NRU: 'Nauru',
  NPL: 'Nepal',
  NLD: 'Netherlands',
  NCL: 'New Caledonia',
  NZL: 'New Zealand',
  NIC: 'Nicaragua',
  NER: 'Niger',
  NGA: 'Nigeria',
  NIU: 'Niue',
  NFK: 'Norfolk Island',
  MKD: 'North Macedonia',
  MNP: 'Northern Mariana Islands',
  NOR: 'Norway',
  OMN: 'Oman',
  PAK: 'Pakistan',
  PLW: 'Palau',
  PSE: 'Palestine',
  PAN: 'Panama',
  PNG: 'Papua New Guinea',
  PRY: 'Paraguay',
  PER: 'Peru',
  PHL: 'Philippines',
  PCN: 'Pitcairn',
  POL: 'Poland',
  PRT: 'Portugal',
  PRI: 'Puerto Rico',
  QAT: 'Qatar',
  REU: 'Réunion',
  ROU: 'Romania',
  RUS: 'Russia',
  RWA: 'Rwanda',
  BLM: 'Saint Barthélemy',
  SHN: 'Saint Helena, Ascension and Tristan da Cunha',
  KNA: 'Saint Kitts and Nevis',
  LCA: 'Saint Lucia',
  MAF: 'Saint Martin',
  SPM: 'Saint Pierre and Miquelon',
  VCT: 'Saint Vincent and the Grenadines',
  WSM: 'Samoa',
  SMR: 'San Marino',
  STP: 'Sao Tome and Principe',
  SAU: 'Saudi Arabia',
  SEN: 'Senegal',
  SRB: 'Serbia',
  SYC: 'Seychelles',
  SLE: 'Sierra Leone',
  SGP: 'Singapore',
  SXM: 'Sint Maarten',
  SVK: 'Slovakia',
  SVN: 'Slovenia',
  SLB: 'Solomon Islands',
  SOM: 'Somalia',
  ZAF: 'South Africa',
  SGS: 'South Georgia and the South Sandwich Islands',
  SSD: 'South Sudan',
  ESP: 'Spain',
  LKA: 'Sri Lanka',
  SDN: 'Sudan',
  SUR: 'Suriname',
  SJM: 'Svalbard and Jan Mayen',
  SWE: 'Sweden',
  CHE: 'Switzerland',
  SYR: 'Syria',
  TWN: 'Taiwan',
  TJK: 'Tajikistan',
  TZA: 'Tanzania',
  THA: 'Thailand',
  TLS: 'Timor-Leste',
  TGO: 'Togo',
  TKL: 'Tokelau',
  TON: 'Tonga',
  TTO: 'Trinidad and Tobago',
  TUN: 'Tunisia',
  TUR: 'Turkey',
  TKM: 'Turkmenistan',
  TCA: 'Turks and Caicos Islands',
  TUV: 'Tuvalu',
  UGA: 'Uganda',
  UKR: 'Ukraine',
  ARE: 'United Arab Emirates',
  GBR: 'United Kingdom',
  USA: 'United States of America',
  UMI: 'United States Minor Outlying Islands',
  URY: 'Uruguay',
  UZB: 'Uzbekistan',
  VUT: 'Vanuatu',
  VEN: 'Venezuela',
  VNM: 'Vietnam',
  VGB: 'Virgin Islands (British)',
  VIR: 'Virgin Islands (U.S.)',
  WLF: 'Wallis and Futuna',
  ESH: 'Western Sahara',
  YEM: 'Yemen',
  ZMB: 'Zambia',
  ZWE: 'Zimbabwe',
};

export const SortedCategoryCodes: Record<string, string> = {
  A1_RENT_A_CAR: 'A1 Rent A Car',
  ACCENT_RENT_A_CAR: 'Accent Rent A Car',
  ACCOUNTING_BOOKKEEPING_SERVICES: 'Accounting Bookkeeping Services',
  ACTION_AUTO_RENTAL: 'Action Auto Rental',
  AC_REFRIGERATION_REPAIR: 'Ac Refrigeration Repair',
  ADAMS_MARK: 'Adams Mark',
  ADRIA_AIR: 'Adria Air',
  ADVANTAGE_RENT_A_CAR: 'Advantage Rent A Car',
  ADVERTISING_SERVICES: 'Advertising Services',
  AEORFLOT: 'Aeorflot',
  AEROLINEAS_ARGENTINAS: 'Aerolineas Argentinas',
  AEROMEXICO: 'Aeromexico',
  AERO_COACH_AVIATION: 'Aero Coach Aviation',
  AERO_CONTINENTE: 'Aero Continente',
  AERO_NICARAGUENSIS: 'Aero Nicaraguensis',
  AERO_PERU: 'Aero Peru',
  AERO_VIRGIN_ISLANDS: 'Aero Virgin Islands',
  AER_LINGUS: 'Aer Lingus',
  AFFILIATED_AUTO_RENTAL: 'Affiliated Auto Rental',
  AFFINIA: 'Affinia',
  AGENCY_RENT_A_CAR: 'Agency Rent A Car',
  AGRICULTURAL_COOPERATIVE: 'Agricultural Cooperative',
  AIRINTER: 'Airinter',
  AIRLINES_AIR_CARRIERS: 'Airlines Air Carriers',
  AIRPORTS_FLYING_FIELDS: 'Airports Flying Fields',
  AIRTRAN_AIRWAYS: 'Airtran Airways',
  AIRWAYS: 'Airways',
  AIR_AFRIQUE: 'Air Afrique',
  AIR_ALGERIE: 'Air Algerie',
  AIR_ARABIA: 'Air Arabia',
  AIR_ASTANA: 'Air Astana',
  AIR_BERLIN: 'Air Berlin',
  AIR_BRITISH_COLUMBIA: 'Air British Columbia',
  AIR_CANADA: 'Air Canada',
  AIR_CHINA: 'Air China',
  AIR_DJIBOUTI: 'Air Djibouti',
  AIR_FRANCE: 'Air France',
  AIR_INDIA: 'Air India',
  AIR_JAMAICA: 'Air Jamaica',
  AIR_LANKA: 'Air Lanka',
  AIR_LITTORAL: 'Air Littoral',
  AIR_MALTA: 'Air Malta',
  AIR_MAROC: 'Air Maroc',
  AIR_MAURITIUS: 'Air Mauritius',
  AIR_NEW_ZEALAND: 'Air New Zealand',
  AIR_PANAMA: 'Air Panama',
  AIR_SEYCHELLES: 'Air Seychelles',
  AIR_ZAIRE: 'Air Zaire',
  AIR_ZIMBABWE_CORP: 'Air Zimbabwe Corp',
  AJAX_RENT_A_CAR: 'Ajax Rent A Car',
  ALADDIN_RESORT_AND_CASINO: 'Aladdin Resort And Casino',
  ALAMO_RENT_A_CAR: 'Alamo Rent A Car',
  ALASKA_AIR: 'Alaska Air',
  ALA_MOANA_HOTEL: 'Ala Moana Hotel',
  ALITALIA: 'Alitalia',
  ALLSTATE: 'Allstate',
  ALM_AIRLINE: 'Alm Airline',
  ALOFT: 'Aloft',
  ALOHA_AIRLINES: 'Aloha Airlines',
  ALTRA_AUTO_RENTAL: 'Altra Auto Rental',
  AMBULANCE_SERVICES: 'Ambulance Services',
  AMELIA_ISLAND_PLANTATION: 'Amelia Island Plantation',
  AMERICANA_HOTELS_CORPORATION: 'Americana Hotels Corporation',
  AMERICAN_AIRLINES: 'American Airlines',
  AMERICAN_INTERNATIONAL: 'American International',
  AMERICAS_BEST_VALUE_INN: 'Americas Best Value Inn',
  AMERICA_WEST: 'America West',
  AMERICINN: 'Americinn',
  AMERISUITES: 'Amerisuites',
  AMFAC_HOTELS: 'Amfac Hotels',
  AMUSEMENT_PARKS_CARNIVALS: 'Amusement Parks Carnivals',
  ANA_AIR: 'Ana Air',
  ANA_HOTELS: 'Ana Hotels',
  ANSA_INTERNATIONAL: 'Ansa International',
  ANSETT_AIRLINES: 'Ansett Airlines',
  ANTIQUE_REPRODUCTIONS: 'Antique Reproductions',
  ANTIQUE_SHOPS: 'Antique Shops',
  AQUARIUMS: 'Aquariums',
  ARABELLA_HOTELS: 'Arabella Hotels',
  ARCADE: 'Arcade',
  ARCHITECTURAL_SURVEYING_SERVICES: 'Architectural Surveying Services',
  ARCTIA: 'Arctia',
  ARIA: 'Aria',
  ARIZONA_BILTMORE: 'Arizona Biltmore',
  ARTISTS_SUPPLY_AND_CRAFT_SHOPS: 'Artists Supply And Craft Shops',
  ART_DEALERS_AND_GALLERIES: 'Art Dealers And Galleries',
  ASC_AIRLINE: 'Asc Airline',
  ASIANA_AIRLINES: 'Asiana Airlines',
  ATA_AIR: 'Ata Air',
  ATLANTIC_CITY_HILTON: 'Atlantic City Hilton',
  AUBERGE_DES_GOVERNEURS: 'Auberge Des Governeurs',
  AUSTRIAN_AIR: 'Austrian Air',
  AUSTRIAN_AIR_SERVICE: 'Austrian Air Service',
  AUTOGRAPH: 'Autograph',
  AUTOHANSA: 'Autohansa',
  AUTOMATE: 'Automate',
  AUTOMATED_CASH_DISBURSE: 'Automated Cash Disburse',
  AUTOMATED_FUEL_DISPENSERS: 'Automated Fuel Dispensers',
  AUTOMOBILE_ASSOCIATIONS: 'Automobile Associations',
  AUTOMOTIVE_PARTS_AND_ACCESSORIES_STORES: 'Automotive Parts And Accessories Stores',
  AUTOMOTIVE_TIRE_STORES: 'Automotive Tire Stores',
  AUTO_AND_HOME_SUPPLY_STORES: 'Auto And Home Supply Stores',
  AUTO_BODY_REPAIR_SHOPS: 'Auto Body Repair Shops',
  AUTO_HOST_RENTAL_CARS: 'Auto Host Rental Cars',
  AUTO_PAINT_SHOPS: 'Auto Paint Shops',
  AUTO_SERVICE_SHOPS: 'Auto Service Shops',
  AVCAR: 'Avcar',
  AVENSA_AIR: 'Avensa Air',
  AVIACO_AIR: 'Aviaco Air',
  AVIANCA: 'Avianca',
  AVIATECA_AIR: 'Aviateca Air',
  AVIS_RENT_A_CAR: 'Avis Rent A Car',
  AVON_RENT_A_CAR: 'Avon Rent A Car',
  AZUL_BRAZILIAN_AIRLINES: 'Azul Brazilian Airlines',
  BAHAMAS_AIR: 'Bahamas Air',
  BAIL_AND_BOND_PAYMENTS: 'Bail And Bond Payments',
  BAKERIES: 'Bakeries',
  BALKAN_AIR: 'Balkan Air',
  BALLYS_HOTEL_AND_CASINO: 'Ballys Hotel And Casino',
  BANDS_ORCHESTRAS: 'Bands Orchestras',
  BARBER_AND_BEAUTY_SHOPS: 'Barber And Beauty Shops',
  BARTON_CREEK_RESORT: 'Barton Creek Resort',
  BAR_HARBOR_AIRLINES: 'Bar Harbor Airlines',
  BEAU_RIVAGE_HOTEL_AND_CASINO: 'Beau Rivage Hotel And Casino',
  BELLAGIO: 'Bellagio',
  BEMIDJI_AIR: 'Bemidji Air',
  BEST_WESTERN: 'Best Western',
  BETTING_CASINO_GAMBLING: 'Betting Casino Gambling',
  BEVERLY_HILLS_HOTEL: 'Beverly Hills Hotel',
  BICYCLE_SHOPS: 'Bicycle Shops',
  BILLIARD_POOL_ESTABLISHMENTS: 'Billiard Pool Establishments',
  BILTMORE_HOTEL_AND_SUITES: 'Biltmore Hotel And Suites',
  BINIONS_HORSESHOE_CLUB: 'Binions Horseshoe Club',
  BLUEPRINTING_AND_PHOTOCOPYING_SERVICES: 'Blueprinting And Photocopying Services',
  BOAT_DEALERS: 'Boat Dealers',
  BOAT_RENTALS_AND_LEASES: 'Boat Rentals And Leases',
  BOCA_RATON_RESORT: 'Boca Raton Resort',
  BOOKS_PERIODICALS_AND_NEWSPAPERS: 'Books Periodicals And Newspapers',
  BOOK_STORES: 'Book Stores',
  BOWLING_ALLEYS: 'Bowling Alleys',
  BRAATHENS: 'Braathens',
  BRADBURY_SUITES: 'Bradbury Suites',
  BREAKERS_RESORT: 'Breakers Resort',
  BRITISH_AIRWAYS: 'British Airways',
  BRITISH_MIDLAND_AIR: 'British Midland Air',
  BROADMOOR_HOTEL: 'Broadmoor Hotel',
  BROCKWAY_AIR: 'Brockway Air',
  BROOKS_RENT_A_CAR: 'Brooks Rent A Car',
  BUDGETEL: 'Budgetel',
  BUDGET_HOST_INNS: 'Budget Host Inns',
  BUDGET_RENT_A_CAR: 'Budget Rent A Car',
  BUFFALO_BILLS_HOTEL_AND_CASINO: 'Buffalo Bills Hotel And Casino',
  BUSINESS_SECRETARIAL_SCHOOLS: 'Business Secretarial Schools',
  BUS_LINES: 'Bus Lines',
  BUYING_SHOPPING_SERVICES: 'Buying Shopping Services',
  CABLE_SATELLITE_AND_OTHER_PAY_TELEVISION_AND_RADIO: 'Cable Satellite And Other Pay Television And Radio',
  CAESARS_HOTEL_AND_CASINO: 'Caesars Hotel And Casino',
  CALIFORNIA_HOTEL_AND_CASINO: 'California Hotel And Casino',
  CAMERA_AND_PHOTOGRAPHIC_SUPPLY_STORES: 'Camera And Photographic Supply Stores',
  CAMPANILE: 'Campanile',
  CANADIAN_AIR: 'Canadian Air',
  CANADIAN_PACIFIC: 'Canadian Pacific',
  CANDLEWOOD_SUITES: 'Candlewood Suites',
  CANDY_NUT_AND_CONFECTIONERY_STORES: 'Candy Nut And Confectionery Stores',
  CANYON_RANCH: 'Canyon Ranch',
  CAPITOL_AIR: 'Capitol Air',
  CAREFREE_RESORTS: 'Carefree Resorts',
  CAREY: 'Carey',
  CARIBBEAN_AIRLINES: 'Caribbean Airlines',
  CARIBE_ROYAL: 'Caribe Royal',
  CARIBE_ROYAL_RESORT_SUITE_AND_VILLAS: 'Caribe Royal Resort Suite And Villas',
  CARLTON_HOTELS: 'Carlton Hotels',
  CARNIVAL_AIRLINES: 'Carnival Airlines',
  CARPENTRY_SERVICES: 'Carpentry Services',
  CARPET_UPHOLSTERY_CLEANING: 'Carpet Upholstery Cleaning',
  CAR_AND_TRUCK_DEALERS_NEW_USED: 'Car And Truck Dealers New Used',
  CAR_AND_TRUCK_DEALERS_USED_ONLY: 'Car And Truck Dealers Used Only',
  CAR_RENTAL: 'Car Rental',
  CAR_RENTAL_AGENCIES: 'Car Rental Agencies',
  CAR_WASHES: 'Car Washes',
  CATERERS: 'Caterers',
  CATHAY_PACIFIC: 'Cathay Pacific',
  CAYMAN_AIRWAYS: 'Cayman Airways',
  CEBU_PACIFIC_AIRLINES: 'Cebu Pacific Airlines',
  CHAMPAGNE_PRODUCERS: 'Champagne Producers',
  CHARITABLE_AND_SOCIAL_SERVICE_ORGANIZATIONS_FUNDRAISING:
    'Charitable And Social Service Organizations Fundraising',
  CHATEAU_ELAN_WINERY_AND_RESORT: 'Chateau Elan Winery And Resort',
  CHEMICALS_AND_ALLIED_PRODUCTS: 'Chemicals And Allied Products',
  CHILDRENS_AND_INFANTS_WEAR_STORES: 'Childrens And Infants Wear Stores',
  CHILD_CARE_SERVICES: 'Child Care Services',
  CHINA_AIRLINES: 'China Airlines',
  CHINA_EASTERN_AIRLINES: 'China Eastern Airlines',
  CHINA_SOUTHERN_AIRLINES: 'China Southern Airlines',
  CHIROPODISTS_PODIATRISTS: 'Chiropodists Podiatrists',
  CHIROPRACTORS: 'Chiropractors',
  CIGAHOTELS: 'Cigahotels',
  CIGAR_STORES_AND_STANDS: 'Cigar Stores And Stands',
  CIRCUS_CIRCUS_HOTEL_AND_CASINO: 'Circus Circus Hotel And Casino',
  CITE: 'Cite',
  CITY_LODGE_HOTELS: 'City Lodge Hotels',
  CIVIC_SOCIAL_FRATERNAL_ASSOCIATIONS: 'Civic Social Fraternal Associations',
  CLARIDGE_CASINO_HOTEL: 'Claridge Casino Hotel',
  CLARION_HOTEL: 'Clarion Hotel',
  CLEANING_AND_MAINTENANCE: 'Cleaning And Maintenance',
  CLIMAT_DE_FRANCE: 'Climat De France',
  CLOTHING_RENTAL: 'Clothing Rental',
  CLUB_CORPORATION_CLUB_RESORTS: 'Club Corporation Club Resorts',
  CLUB_MED: 'Club Med',
  COAST_HOTELS: 'Coast Hotels',
  COLLEGES_UNIVERSITIES: 'Colleges Universities',
  COLORADO_BELLE_EDGEWATER_RESORT: 'Colorado Belle Edgewater Resort',
  COMAIR: 'Comair',
  COMFORT_HOTEL_INTERNATIONAL: 'Comfort Hotel International',
  COMMAND_AIR: 'Command Air',
  COMMERCIAL_EQUIPMENT: 'Commercial Equipment',
  COMMERCIAL_FOOTWEAR: 'Commercial Footwear',
  COMMERCIAL_PHOTOGRAPHY_ART_AND_GRAPHICS: 'Commercial Photography Art And Graphics',
  COMMUTER_TRANSPORT_AND_FERRIES: 'Commuter Transport And Ferries',
  COMPRI_HOTEL: 'Compri Hotel',
  COMPUTERS_PERIPHERALS_AND_SOFTWARE: 'Computers Peripherals And Software',
  COMPUTER_NETWORK_SERVICES: 'Computer Network Services',
  COMPUTER_PROGRAMMING: 'Computer Programming',
  COMPUTER_REPAIR: 'Computer Repair',
  COMPUTER_SOFTWARE_STORES: 'Computer Software Stores',
  COMP_FAU_AIR: 'Comp Fau Air',
  CONCESSION: 'Concession',
  CONCORDE_HOTELS: 'Concorde Hotels',
  CONCRETE_WORK_SERVICES: 'Concrete Work Services',
  CONRAD_HOTELS: 'Conrad Hotels',
  CONSORT: 'Consort',
  CONSTRUCTION_MATERIALS: 'Construction Materials',
  CONSULTING_PUBLIC_RELATIONS: 'Consulting Public Relations',
  CONTINENTAL_AIRLINES: 'Continental Airlines',
  COPA_AIR: 'Copa Air',
  CORRESPONDENCE_SCHOOLS: 'Correspondence Schools',
  COSMETIC_STORES: 'Cosmetic Stores',
  COSMOPOLITAN_OF_LAS_VEGAS: 'Cosmopolitan Of Las Vegas',
  COUNSELING_SERVICES: 'Counseling Services',
  COUNTRY_CLUBS: 'Country Clubs',
  COUNTRY_INN_BY_CARLSON: 'Country Inn By Carlson',
  COURIER_SERVICES: 'Courier Services',
  COURTYARD_BY_MARRIOTT: 'Courtyard By Marriott',
  COURT_COSTS: 'Court Costs',
  CREDIT_REPORTING_AGENCIES: 'Credit Reporting Agencies',
  CREST_HOTELS: 'Crest Hotels',
  CROATIA_AIR: 'Croatia Air',
  CROSSLAND: 'Crossland',
  CROWNE_PLAZA_HOTELS: 'Crowne Plaza Hotels',
  CROWN_AIR: 'Crown Air',
  CRUISE_LINES: 'Cruise Lines',
  CRUZIERO_AIR: 'Cruziero Air',
  CSA_AIRLINE: 'Csa Airline',
  CUMBERLAND_AIRLINES: 'Cumberland Airlines',
  CUMULUS_HOTELS: 'Cumulus Hotels',
  CUNARD_HOTELS: 'Cunard Hotels',
  CYPRUS_AIRWAYS: 'Cyprus Airways',
  C_MON_INN: 'C Mon Inn',
  DAIRY_PRODUCTS_STORES: 'Dairy Products Stores',
  DANCE_HALL_STUDIOS_SCHOOLS: 'Dance Hall Studios Schools',
  DAN_AIR_SERVICES: 'Dan Air Services',
  DAN_HOTELS: 'Dan Hotels',
  DATING_ESCORT_SERVICES: 'Dating Escort Services',
  DAYS_INNS_OF_AMERICA: 'Days Inns Of America',
  DBA_AIR: 'Dba Air',
  DELTA_AIRLINES: 'Delta Airlines',
  DELTA_HOTELS: 'Delta Hotels',
  DENTISTS_ORTHODONTISTS: 'Dentists Orthodontists',
  DEPARTMENT_STORES: 'Department Stores',
  DETECTIVE_AGENCIES: 'Detective Agencies',
  DE_VERE_HOTELS: 'De Vere Hotels',
  DIGITAL_GOODS_APPLICATIONS: 'Digital Goods Applications',
  DIGITAL_GOODS_GAMES: 'Digital Goods Games',
  DIGITAL_GOODS_LARGE_VOLUME: 'Digital Goods Large Volume',
  DIGITAL_GOODS_MEDIA: 'Digital Goods Media',
  DILLON_INN: 'Dillon Inn',
  DIRECT_MARKETING_CATALOG_MERCHANT: 'Direct Marketing Catalog Merchant',
  DIRECT_MARKETING_COMBINATION_CATALOG_AND_RETAIL_MERCHANT:
    'Direct Marketing Combination Catalog And Retail Merchant',
  DIRECT_MARKETING_INBOUND_TELEMARKETING: 'Direct Marketing Inbound Telemarketing',
  DIRECT_MARKETING_INSURANCE_SERVICES: 'Direct Marketing Insurance Services',
  DIRECT_MARKETING_OTHER: 'Direct Marketing Other',
  DIRECT_MARKETING_OUTBOUND_TELEMARKETING: 'Direct Marketing Outbound Telemarketing',
  DIRECT_MARKETING_SUBSCRIPTION: 'Direct Marketing Subscription',
  DIRECT_MARKETING_TRAVEL: 'Direct Marketing Travel',
  DISCOUNT_STORES: 'Discount Stores',
  DISNEYLAND_RESORTS: 'Disneyland Resorts',
  DOCTORS: 'Doctors',
  DOLLAR_RENT_A_CAR: 'Dollar Rent A Car',
  DOMINICA_AIR: 'Dominica Air',
  DOOR_TO_DOOR_SALES: 'Door To Door Sales',
  DORAL_GOLF_RESORT: 'Doral Golf Resort',
  DORAL_HOTELS: 'Doral Hotels',
  DORINT_HOTELS: 'Dorint Hotels',
  DOUBLETREE: 'Doubletree',
  DOWNTOWNER_PASSPORT: 'Downtowner Passport',
  DRAPERY_WINDOW_COVERING_AND_UPHOLSTERY_STORES: 'Drapery Window Covering And Upholstery Stores',
  DRINKING_PLACES: 'Drinking Places',
  DRUGS_DRUG_PROPRIETARIES_AND_DRUGGIST_SUNDRIES: 'Drugs Drug Proprietaries And Druggist Sundries',
  DRUG_STORES_AND_PHARMACIES: 'Drug Stores And Pharmacies',
  DRURY_INN: 'Drury Inn',
  DRY_CLEANERS: 'Dry Cleaners',
  DUNFEY_HOTELS: 'Dunfey Hotels',
  DURABLE_GOODS: 'Durable Goods',
  DUTY_FREE_STORES: 'Duty Free Stores',
  EASYJET_AIR: 'Easyjet Air',
  EATING_PLACES_RESTAURANTS: 'Eating Places Restaurants',
  ECONOMY_INNS_OF_AMERICA: 'Economy Inns Of America',
  ECONO_CAR_RENT_A_CAR: 'Econo Car Rent A Car',
  ECONO_TRAVEL_MOTOR_HOTEL: 'Econo Travel Motor Hotel',
  ECUATORIANA: 'Ecuatoriana',
  EDUCATIONAL_SERVICES: 'Educational Services',
  EGYPT_AIR: 'Egypt Air',
  ELDORADO_HOTEL_AND_CASINO: 'Eldorado Hotel And Casino',
  ELECTRICAL_PARTS_AND_EQUIPMENT: 'Electrical Parts And Equipment',
  ELECTRICAL_SERVICES: 'Electrical Services',
  ELECTRIC_RAZOR_STORES: 'Electric Razor Stores',
  ELECTRIC_VEHICLE_CHARGING: 'Electric Vehicle Charging',
  ELECTRONICS_REPAIR_SHOPS: 'Electronics Repair Shops',
  ELECTRONICS_STORES: 'Electronics Stores',
  ELEMENT: 'Element',
  ELEMENTARY_SECONDARY_SCHOOLS: 'Elementary Secondary Schools',
  EL_AL_AIRLINES: 'El Al Airlines',
  EMBASSY_HOTELS: 'Embassy Hotels',
  EMBASSY_SUITES: 'Embassy Suites',
  EMBASSY_VACATION_RESORT: 'Embassy Vacation Resort',
  EMIRATES: 'Emirates',
  EMPLOYMENT_TEMP_AGENCIES: 'Employment Temp Agencies',
  ENTERPRISE_RENT_A_CAR: 'Enterprise Rent A Car',
  EQUIPMENT_RENTAL: 'Equipment Rental',
  ETHIOPIAN_AIRLINES: 'Ethiopian Airlines',
  ETIHAD_AIR: 'Etihad Air',
  EUROPCAR: 'Europcar',
  EUROPE_BY_CAR: 'Europe By Car',
  EVA_AIRWAYS: 'Eva Airways',
  EXCALIBUR_HOTEL_AND_CASINO: 'Excalibur Hotel And Casino',
  EXCEL_INN: 'Excel Inn',
  EXTENDED_STAY: 'Extended Stay',
  EXTENDED_STAY_AMERICA: 'Extended Stay America',
  EXTENDED_STAY_DELUXE: 'Extended Stay Deluxe',
  EXTERMINATING_SERVICES: 'Exterminating Services',
  FAIRFIELD_HOTEL: 'Fairfield Hotel',
  FAIRFIELD_INN: 'Fairfield Inn',
  FAIRMONT_HOTELS_CORPORATION: 'Fairmont Hotels Corporation',
  FAMILY_CLOTHING_STORES: 'Family Clothing Stores',
  FAST_FOOD: 'Fast Food',
  FAST_FOOD_RESTAURANTS: 'Fast Food Restaurants',
  FINANCIAL_INSTITUTIONS: 'Financial Institutions',
  FINES_GOVERNMENT_ADMINISTRATIVE_ENTITIES: 'Fines Government Administrative Entities',
  FINNAIR: 'Finnair',
  FIREPLACE_FIREPLACE_SCREENS_AND_ACCESSORIES_STORES: 'Fireplace Fireplace Screens And Accessories Stores',
  FIRST_HOSPITALITY_HOTELS: 'First Hospitality Hotels',
  FLAG_INNS: 'Flag Inns',
  FLAG_INNS_AUSTRALIA: 'Flag Inns Australia',
  FLOOR_COVERING_STORES: 'Floor Covering Stores',
  FLORISTS: 'Florists',
  FLORISTS_SUPPLIES_NURSERY_STOCK_AND_FLOWERS: 'Florists Supplies Nursery Stock And Flowers',
  FLYBE: 'Flybe',
  FONTAINEBLEAU_RESORT: 'Fontainebleau Resort',
  FOUR_POINTS_HOTELS: 'Four Points Hotels',
  FOUR_SEASONS: 'Four Seasons',
  FOUR_SEASONS_AUSTRALIA: 'Four Seasons Australia',
  FRANKENMUTH_BAVARIAN: 'Frankenmuth Bavarian',
  FREEDOM_AIRLINES: 'Freedom Airlines',
  FREEZER_AND_LOCKER_MEAT_PROVISIONERS: 'Freezer And Locker Meat Provisioners',
  FREMONT_HOTEL_AND_CASINO: 'Fremont Hotel And Casino',
  FRIENDSHIP_INNS_INTERNATIONAL: 'Friendship Inns International',
  FRONTIER_AIRLINES: 'Frontier Airlines',
  FUEL_DEALERS_NON_AUTOMOTIVE: 'Fuel Dealers Non Automotive',
  FUNDING_TRANSACTION: 'Funding Transaction',
  FUNERAL_SERVICES_CREMATORIES: 'Funeral Services Crematories',
  FURNITURE_HOME_FURNISHINGS_AND_EQUIPMENT_STORES_EXCEPT_APPLIANCES:
    'Furniture Home Furnishings And Equipment Stores Except Appliances',
  FURNITURE_REPAIR_REFINISHING: 'Furniture Repair Refinishing',
  FURRIERS_AND_FUR_SHOPS: 'Furriers And Fur Shops',
  GALT_HOUSE: 'Galt House',
  GARDEN_PLACE_HOTEL: 'Garden Place Hotel',
  GARUDA: 'Garuda',
  GAYLORD_OPRYLAND: 'Gaylord Opryland',
  GAYLORD_PALMS: 'Gaylord Palms',
  GAYLORD_TEXAN: 'Gaylord Texan',
  GENERAL_RENT_A_CAR: 'General Rent A Car',
  GENERAL_SERVICES: 'General Services',
  GIFT_CARD_NOVELTY_AND_SOUVENIR_SHOPS: 'Gift Card Novelty And Souvenir Shops',
  GLASSWARE_CRYSTAL_STORES: 'Glassware Crystal Stores',
  GLASS_PAINT_AND_WALLPAPER_STORES: 'Glass Paint And Wallpaper Stores',
  GODFREY_NATIONAL: 'Godfrey National',
  GOFLY: 'Gofly',
  GOLDEN_NUGGET: 'Golden Nugget',
  GOLDEN_PACIFIC_AIR: 'Golden Pacific Air',
  GOLDEN_TULIP: 'Golden Tulip',
  GOLF_COURSES_PUBLIC: 'Golf Courses Public',
  GOL_AIRLINES: 'Gol Airlines',
  GOVERNMENT_LICENSED_HORSE_OR_DOG_RACING: 'Government Licensed Horse Or Dog Racing',
  GOVERNMENT_LICENSED_ON_LINE_CASINO: 'Government Licensed On Line Casino',
  GOVERNMENT_OWNED_LOTTERY: 'Government Owned Lottery',
  GOVERNMENT_OWNED_LOTTERY_GLOBAL: 'Government Owned Lottery Global',
  GOVERNMENT_SERVICES: 'Government Services',
  GRAND_CASINO_HOTELS: 'Grand Casino Hotels',
  GRAND_MET_FORUM_HOTELS: 'Grand Met Forum Hotels',
  GRAND_SIERRA_RESORT: 'Grand Sierra Resort',
  GRAND_WAILEA_RESORT: 'Grand Wailea Resort',
  GREAT_WOLF: 'Great Wolf',
  GREENBRIAR_RESORTS: 'Greenbriar Resorts',
  GROCERY_STORES_SUPERMARKETS: 'Grocery Stores Supermarkets',
  GRUPO_HOTELS_HUSA_SA: 'Grupo Hotels Husa Sa',
  GULF_AIR: 'Gulf Air',
  GUNS_AMMO: 'Guns Ammo',
  GUYANA_AIRWAYS: 'Guyana Airways',
  HAINAN_AIRLINES: 'Hainan Airlines',
  HALEKULANI_HOTEL_WAIKIKI_PARC: 'Halekulani Hotel Waikiki Parc',
  HALE_KOA_HOTEL: 'Hale Koa Hotel',
  HAMPTON_INNS: 'Hampton Inns',
  HARDWARE_EQUIPMENT_AND_SUPPLIES: 'Hardware Equipment And Supplies',
  HARDWARE_STORES: 'Hardware Stores',
  HARLEY_HOTEL: 'Harley Hotel',
  HARRAHS_HOTELS_AND_CASINOS: 'Harrahs Hotels And Casinos',
  HARVEY_BRISTOL_HOTELS: 'Harvey Bristol Hotels',
  HAVASU_AIRLINES: 'Havasu Airlines',
  HAWAIIAN_AIR: 'Hawaiian Air',
  HEALTH_AND_BEAUTY_SPAS: 'Health And Beauty Spas',
  HEARING_AIDS_SALES_AND_SUPPLIES: 'Hearing Aids Sales And Supplies',
  HEATING_PLUMBING_A_C: 'Heating Plumbing A C',
  HELMSLEY_HOTELS: 'Helmsley Hotels',
  HERMITAGE_HOTELS: 'Hermitage Hotels',
  HERTZ: 'Hertz',
  HILTON: 'Hilton',
  HILTON_GARDEN_INN: 'Hilton Garden Inn',
  HILTON_INTERNATIONAL: 'Hilton International',
  HLX_AIR: 'Hlx Air',
  HOBBY_TOY_AND_GAME_SHOPS: 'Hobby Toy And Game Shops',
  HOLIDAY_INNS: 'Holiday Inns',
  HOLIDAY_RENT_A_CAR: 'Holiday Rent A Car',
  HOME2SUITES: 'Home2suites',
  HOMESTEAD: 'Homestead',
  HOMESTEAD_SUITES: 'Homestead Suites',
  HOMEWOOD_SUITES: 'Homewood Suites',
  HOME_2_SUITES: 'Home 2 Suites',
  HOME_SUPPLY_WAREHOUSE_STORES: 'Home Supply Warehouse Stores',
  HOSPITALITY_INNS: 'Hospitality Inns',
  HOSPITALS: 'Hospitals',
  HOTEIS_OTHAN: 'Hoteis Othan',
  HOTELES_EL_PRESIDENTE: 'Hoteles El Presidente',
  HOTELS_MELIA: 'Hotels Melia',
  HOTELS_MOTELS_AND_RESORTS: 'Hotels Motels And Resorts',
  HOTEL_DEL_CORONADO: 'Hotel Del Coronado',
  HOTEL_INDIGO: 'Hotel Indigo',
  HOTEL_MERCURE: 'Hotel Mercure',
  HOTEL_OKURA: 'Hotel Okura',
  HOTEL_SIERRA: 'Hotel Sierra',
  HOTEL_UNIVERSAL: 'Hotel Universal',
  HOUSEHOLD_APPLIANCE_STORES: 'Household Appliance Stores',
  HOWARD_JOHNSON: 'Howard Johnson',
  HUDSON_HOTEL: 'Hudson Hotel',
  HUNGAR_HOTELS: 'Hungar Hotels',
  HYATT_HOTELS_INTERNATIONAL: 'Hyatt Hotels International',
  HYATT_PLACE: 'Hyatt Place',
  IBERIA: 'Iberia',
  IBEROTEL: 'Iberotel',
  IBUSZ_HOTELS: 'Ibusz Hotels',
  ICELAND_AIR: 'Iceland Air',
  IMPERIAL_LONDON_HOTELS: 'Imperial London Hotels',
  INDIAN_AIRLINES: 'Indian Airlines',
  INDUSTRIAL_SUPPLIES: 'Industrial Supplies',
  INFORMATION_RETRIEVAL_SERVICES: 'Information Retrieval Services',
  INSURANCE_AGENTS_BROKERS_SERVICE: 'Insurance Agents Brokers Service',
  INSURANCE_DEFAULT: 'Insurance Default',
  INSURANCE_PREMIUMS: 'Insurance Premiums',
  INSURANCE_RENT_A_CAR: 'Insurance Rent A Car',
  INSURANCE_UNDERWRITING_PREMIUMS: 'Insurance Underwriting Premiums',
  INTERCONTINENTAL: 'Intercontinental',
  INTERENT: 'Interent',
  INTERHOTEL_CEDOK: 'Interhotel Cedok',
  INTER_NOR_HOTELS: 'Inter Nor Hotels',
  INTRA_COMPANY_PURCHASES: 'Intra Company Purchases',
  ISLAND_AIRLINES: 'Island Airlines',
  JAPAN_AIRLINES: 'Japan Airlines',
  JEFFERSON_HOTEL: 'Jefferson Hotel',
  JETBLUE_AIRWAYS: 'Jetblue Airways',
  JETSTAR_AIRWAYS: 'Jetstar Airways',
  JET_AIRWAYS: 'Jet Airways',
  JEWELRY_STORES_WATCHES_CLOCKS_AND_SILVERWARE_STORES: 'Jewelry Stores Watches Clocks And Silverware Stores',
  JOHN_ASCUAGAS_NUGGET: 'John Ascuagas Nugget',
  JOLLY_HOTELS: 'Jolly Hotels',
  JOURNEYS_END_MOTELS: 'Journeys End Motels',
  JUGOSLAV_AIR: 'Jugoslav Air',
  JUMEIRAH_ESSEX_HOUSE: 'Jumeirah Essex House',
  JURYS_DOYLE_HOTEL_GROUP: 'Jurys Doyle Hotel Group',
  KAHALA_MANDARIN_ORIENTAL_HOTEL: 'Kahala Mandarin Oriental Hotel',
  KAROS_HOTELS: 'Karos Hotels',
  KAUAI_COCONUT_BEACH_RESORT: 'Kauai Coconut Beach Resort',
  KEMWELL_GROUP: 'Kemwell Group',
  KENYA_AIRWAYS: 'Kenya Airways',
  KLM_ROYAL_DUTCH_AIRLINES: 'Klm Royal Dutch Airlines',
  KNIGHTS_INN: 'Knights Inn',
  KOREAN_AIRLINES: 'Korean Airlines',
  KUWAIT_AIR: 'Kuwait Air',
  KYORITSUHOTELS: 'Kyoritsuhotels',
  LAB_AIR: 'Lab Air',
  LACSA_AIR: 'Lacsa Air',
  LADBROKE_HOTELS: 'Ladbroke Hotels',
  LADECO_AIR: 'Ladeco Air',
  LADY_LUCK_HOTEL_AND_CASINO: 'Lady Luck Hotel And Casino',
  LANDSCAPING_SERVICES: 'Landscaping Services',
  LAN_AIR: 'Lan Air',
  LAP_AIR: 'Lap Air',
  LAUNDRIES: 'Laundries',
  LAUNDRY_CLEANING_SERVICES: 'Laundry Cleaning Services',
  LAV_AIR: 'Lav Air',
  LA_COSTA_RESORT: 'La Costa Resort',
  LA_MANSION_DEL_RIO: 'La Mansion Del Rio',
  LA_QUINTA_MOTOR_INNS: 'La Quinta Motor Inns',
  LA_QUINTA_RESORT: 'La Quinta Resort',
  LEGAL_SERVICES_ATTORNEYS: 'Legal Services Attorneys',
  LIAT_AIRLINE: 'Liat Airline',
  LOEWS_HOTELS: 'Loews Hotels',
  LOT_AIR: 'Lot Air',
  LUFTHANSA: 'Lufthansa',
  LUGGAGE_AND_LEATHER_GOODS_STORES: 'Luggage And Leather Goods Stores',
  LUMBER_BUILDING_MATERIALS_STORES: 'Lumber Building Materials Stores',
  LUXAIR: 'Luxair',
  LUXOR_HOTEL_AND_CASINO: 'Luxor Hotel And Casino',
  LUXURY_RESORTS: 'Luxury Resorts',
  MAINSTAY_SUITES: 'Mainstay Suites',
  MAIN_STREET_STATION_HOTEL_AND_CASINO: 'Main Street Station Hotel And Casino',
  MAJOR_RENT_A_CAR: 'Major Rent A Car',
  MALAYSIAN_AIRLINE_SYSTEM: 'Malaysian Airline System',
  MALEV: 'Malev',
  MALMO_AIR: 'Malmo Air',
  MANDALAY_BAY_RESORT: 'Mandalay Bay Resort',
  MANDARIN_INTERNATIONAL: 'Mandarin International',
  MANHATTAN_EAST_SUITE_HOTELS: 'Manhattan East Suite Hotels',
  MANUAL_CASH_DISBURSE: 'Manual Cash Disburse',
  MARINAS_SERVICE_AND_SUPPLIES: 'Marinas Service And Supplies',
  MARITIM: 'Maritim',
  MARRIOTT: 'Marriott',
  MASONRY_STONEWORK_AND_PLASTER: 'Masonry Stonework And Plaster',
  MASSAGE_PARLORS: 'Massage Parlors',
  MASTERS_ECONOMY_INNS: 'Masters Economy Inns',
  MEDICAL_AND_DENTAL_LABS: 'Medical And Dental Labs',
  MEDICAL_DENTAL_OPHTHALMIC_AND_HOSPITAL_EQUIPMENT_AND_SUPPLIES:
    'Medical Dental Ophthalmic And Hospital Equipment And Supplies',
  MEDICAL_SERVICES: 'Medical Services',
  MEMBERSHIP_ORGANIZATIONS: 'Membership Organizations',
  MENS_AND_BOYS_CLOTHING_AND_ACCESSORIES_STORES: 'Mens And Boys Clothing And Accessories Stores',
  MENS_WOMENS_CLOTHING_STORES: 'Mens Womens Clothing Stores',
  MERCHANTS_RENT_A_CAR: 'Merchants Rent A Car',
  MERIDIEN: 'Meridien',
  MERLIN_HOTEL_PERTH: 'Merlin Hotel Perth',
  MESA_AIR: 'Mesa Air',
  METAL_SERVICE_CENTERS: 'Metal Service Centers',
  METROFLIGHT_AIRLINES: 'Metroflight Airlines',
  METROPOLE_HOTELS: 'Metropole Hotels',
  METRO_AIRLINES: 'Metro Airlines',
  MEXICANA_AIRLINES: 'Mexicana Airlines',
  MGM_GRAND_HOTEL: 'Mgm Grand Hotel',
  MICROTEL_INN_AND_SUITES: 'Microtel Inn And Suites',
  MIDDLE_EAST_AIR: 'Middle East Air',
  MIDWAY_MOTOR_LODGE: 'Midway Motor Lodge',
  MIDWEST_EXPRESS_AIRLINES: 'Midwest Express Airlines',
  MILLENNIUM_BROADWAY_HOTEL: 'Millennium Broadway Hotel',
  MILLEVILLE: 'Milleville',
  MIRAGE_HOTEL_AND_CASINO: 'Mirage Hotel And Casino',
  MISCELLANEOUS_APPAREL_AND_ACCESSORY_SHOPS: 'Miscellaneous Apparel And Accessory Shops',
  MISCELLANEOUS_AUTO_DEALERS: 'Miscellaneous Auto Dealers',
  MISCELLANEOUS_BUSINESS_SERVICES: 'Miscellaneous Business Services',
  MISCELLANEOUS_FOOD_STORES: 'Miscellaneous Food Stores',
  MISCELLANEOUS_GENERAL_MERCHANDISE: 'Miscellaneous General Merchandise',
  MISCELLANEOUS_GENERAL_SERVICES: 'Miscellaneous General Services',
  MISCELLANEOUS_HOME_FURNISHING_SPECIALTY_STORES: 'Miscellaneous Home Furnishing Specialty Stores',
  MISCELLANEOUS_PUBLISHING_AND_PRINTING: 'Miscellaneous Publishing And Printing',
  MISCELLANEOUS_RECREATION_SERVICES: 'Miscellaneous Recreation Services',
  MISCELLANEOUS_REPAIR_SHOPS: 'Miscellaneous Repair Shops',
  MISCELLANEOUS_SPECIALTY_RETAIL: 'Miscellaneous Specialty Retail',
  MIYAKO_HOTEL_KINTETSU: 'Miyako Hotel Kintetsu',
  MOBILE_HOME_DEALERS: 'Mobile Home Dealers',
  MOEVENPICK: 'Moevenpick',
  MONEYSEND_FUNDING: 'Moneysend Funding',
  MONEYSEND_INTERCOUNTRY: 'Moneysend Intercountry',
  MONEYSEND_INTRACOUNTRY: 'Moneysend Intracountry',
  MONTE_CARLO_HOTEL_AND_CASINO: 'Monte Carlo Hotel And Casino',
  MORTGAGE_BANKERS_LOAN_CORRESPONDENTS: 'Mortgage Bankers Loan Correspondents',
  MOTEL_6: 'Motel 6',
  MOTION_PICTURE_THEATERS: 'Motion Picture Theaters',
  MOTORCYCLE_SHOPS_AND_DEALERS: 'Motorcycle Shops And Dealers',
  MOTORCYCLE_SHOPS_DEALERS: 'Motorcycle Shops Dealers',
  MOTOR_FREIGHT_CARRIERS_AND_TRUCKING: 'Motor Freight Carriers And Trucking',
  MOTOR_HOMES_DEALERS: 'Motor Homes Dealers',
  MOTOR_VEHICLE_SUPPLIES_AND_NEW_PARTS: 'Motor Vehicle Supplies And New Parts',
  MOUNT_CHARLOTTE_HOTELS: 'Mount Charlotte Hotels',
  MOUNT_COOK: 'Mount Cook',
  MUSIC_STORES_MUSICAL_INSTRUMENTS_PIANOS_AND_SHEET_MUSIC:
    'Music Stores Musical Instruments Pianos And Sheet Music',
  NATIONAIR: 'Nationair',
  NATIONAL_CAR_RENTAL: 'National Car Rental',
  NEMACOLIN_WOODLANDS: 'Nemacolin Woodlands',
  NEVELE_GRANDE_RESORT_AND_COUNTRY_CLUB: 'Nevele Grande Resort And Country Club',
  NEWS_DEALERS_AND_NEWSSTANDS: 'News Dealers And Newsstands',
  NEW_OTANI_HOTELS: 'New Otani Hotels',
  NEW_YORK_NEW_YORK_HOTEL_AND_CASINO: 'New York New York Hotel And Casino',
  NICKELODEON_FAMILY_SUITES_BY_HOLIDAY_INN: 'Nickelodeon Family Suites By Holiday Inn',
  NIGERIA_AIR: 'Nigeria Air',
  NOAHS_HOTEL_MELBOURNE: 'Noahs Hotel Melbourne',
  NONDURABLE_GOODS: 'Nondurable Goods',
  NON_FI_MONEY_ORDERS: 'Non Fi Money Orders',
  NON_FI_STORED_VALUE_CARD_PURCHASE_LOAD: 'Non Fi Stored Value Card Purchase Load',
  NORD_AIR: 'Nord Air',
  NORONTAIR: 'Norontair',
  NORWEGIAN_AIR_SHUTTLE: 'Norwegian Air Shuttle',
  NOVOTEL_SIEH_ACCOR: 'Novotel Sieh Accor',
  NURSERIES_LAWN_AND_GARDEN_SUPPLY_STORES: 'Nurseries Lawn And Garden Supply Stores',
  NURSING_PERSONAL_CARE: 'Nursing Personal Care',
  NWA_AIR: 'Nwa Air',
  NY_HELI: 'Ny Heli',
  OBEROI_HOTELS: 'Oberoi Hotels',
  OFFICE_AND_COMMERCIAL_FURNITURE: 'Office And Commercial Furniture',
  OHANA_HOTELS_OF_HAWAII: 'Ohana Hotels Of Hawaii',
  OLYMPIC_AIRWAYS: 'Olympic Airways',
  OMAN_AIR: 'Oman Air',
  OMNI_INTERNATIONAL: 'Omni International',
  ONLINE_MARKETPLACES: 'Online Marketplaces',
  OPRYLAND_HOTEL: 'Opryland Hotel',
  OPTICIANS_EYEGLASSES: 'Opticians Eyeglasses',
  OPTOMETRISTS_OPHTHALMOLOGIST: 'Optometrists Ophthalmologist',
  ORCHID_AT_MAUNA_LAI: 'Orchid At Mauna Lai',
  ORTHOPEDIC_GOODS_PROSTHETIC_DEVICES: 'Orthopedic Goods Prosthetic Devices',
  OSTEOPATHS: 'Osteopaths',
  OUTRIGGER_HOTELS_AND_RESORTS: 'Outrigger Hotels And Resorts',
  OXFORD_SUITES: 'Oxford Suites',
  PACKAGE_STORES_BEER_WINE_AND_LIQUOR: 'Package Stores Beer Wine And Liquor',
  PAINTS_VARNISHES_AND_SUPPLIES: 'Paints Varnishes And Supplies',
  PAKISTAN_INTERNATIONAL: 'Pakistan International',
  PANNONIA_HOTELS: 'Pannonia Hotels',
  PAN_AMERICAN: 'Pan American',
  PARIS_LAS_VEGAS_HOTEL: 'Paris Las Vegas Hotel',
  PARKING_LOTS_GARAGES: 'Parking Lots Garages',
  PARKS_INNS_INTERNATIONAL: 'Parks Inns International',
  PARK_INN_BY_RADISSON: 'Park Inn By Radisson',
  PARK_PLAZA_HOTEL: 'Park Plaza Hotel',
  PASSENGER_RAILWAYS: 'Passenger Railways',
  PATRICIA_GRAND_RESORT_HOTELS: 'Patricia Grand Resort Hotels',
  PAWN_SHOPS: 'Pawn Shops',
  PAYLESS_CAR_RENTAL: 'Payless Car Rental',
  PBA_AIRLINE: 'Pba Airline',
  PEABODY_HOTELS: 'Peabody Hotels',
  PENINSULA_HOTELS: 'Peninsula Hotels',
  PENTA_HOTELS: 'Penta Hotels',
  PEPPERMILL_HOTEL_CASINO: 'Peppermill Hotel Casino',
  PERSONAL_CREDIT_INSTITUTIONS: 'Personal Credit Institutions',
  PETROLEUM_AND_PETROLEUM_PRODUCTS: 'Petroleum And Petroleum Products',
  PET_SHOPS_PET_FOOD_AND_SUPPLIES: 'Pet Shops Pet Food And Supplies',
  PHILIPPINE_AIRLINES: 'Philippine Airlines',
  PHOTOGRAPHIC_PHOTOCOPY_MICROFILM_EQUIPMENT_AND_SUPPLIES:
    'Photographic Photocopy Microfilm Equipment And Supplies',
  PHOTOGRAPHIC_STUDIOS: 'Photographic Studios',
  PHOTO_DEVELOPING: 'Photo Developing',
  PICTURE_VIDEO_PRODUCTION: 'Picture Video Production',
  PIECE_GOODS_NOTIONS_AND_OTHER_DRY_GOODS: 'Piece Goods Notions And Other Dry Goods',
  PINEHURST_RESORT: 'Pinehurst Resort',
  PINLESS_DEBIT_BILLPAY_TIER_2: 'Pinless Debit Billpay Tier 2',
  PLM_ETAP_INTERNATIONAL: 'Plm Etap International',
  PLUMBING_HEATING_EQUIPMENT_AND_SUPPLIES: 'Plumbing Heating Equipment And Supplies',
  POLITICAL_ORGANIZATIONS: 'Political Organizations',
  POSTAL_SERVICES_GOVERNMENT_ONLY: 'Postal Services Government Only',
  PRECIOUS_STONES_AND_METALS_WATCHES_AND_JEWELRY: 'Precious Stones And Metals Watches And Jewelry',
  PREMIER_TRAVEL_INNS: 'Premier Travel Inns',
  PRIMADONNA_HOTEL_AND_CASINO: 'Primadonna Hotel And Casino',
  PRINCESS_HOTELS_INTERNATIONAL: 'Princess Hotels International',
  PRINCEVILLE_AIR: 'Princeville Air',
  PRINCEVILLE_RESORT: 'Princeville Resort',
  PRINCE_HOTELS: 'Prince Hotels',
  PROFESSIONAL_SERVICES: 'Professional Services',
  PROTEA_HOTELS: 'Protea Hotels',
  PUBLIC_WAREHOUSING_AND_STORAGE: 'Public Warehousing And Storage',
  QATAR_AIRWAYS: 'Qatar Airways',
  QUALITY_INTERNATIONAL: 'Quality International',
  QUALITY_PACIFIC_HOTEL: 'Quality Pacific Hotel',
  QUANTAS: 'Quantas',
  QUASI_CASH_CUSTOMER_FINANCIAL_INSTITUTIONS: 'Quasi Cash Customer Financial Institutions',
  QUEENS_MOAT_HOUSES: 'Queens Moat Houses',
  QUICK_COPY_REPRO_AND_BLUEPRINT: 'Quick Copy Repro And Blueprint',
  RADISSON: 'Radisson',
  RADISSON_BLU: 'Radisson Blu',
  RAFFLES_HOTELS: 'Raffles Hotels',
  RAILROADS: 'Railroads',
  RAMADA_INNS: 'Ramada Inns',
  RANK_HOTELS: 'Rank Hotels',
  RANTASIPI_HOTELS: 'Rantasipi Hotels',
  REAL_ESTATE_AGENTS_AND_MANAGERS_RENTALS: 'Real Estate Agents And Managers Rentals',
  RECORD_STORES: 'Record Stores',
  RECREATIONAL_VEHICLE_RENTALS: 'Recreational Vehicle Rentals',
  RED_ROOF_INNS: 'Red Roof Inns',
  REGAL_8_INNS: 'Regal 8 Inns',
  REGENT_HOTELS: 'Regent Hotels',
  REGISTRY_HOTELS: 'Registry Hotels',
  RELAX_INNS: 'Relax Inns',
  RELIGIOUS_GOODS_STORES: 'Religious Goods Stores',
  RELIGIOUS_ORGANIZATIONS: 'Religious Organizations',
  RENAISSANCE_HOTELS: 'Renaissance Hotels',
  RENO_AIR: 'Reno Air',
  RENT_A_WRECK: 'Rent A Wreck',
  REPLACEMENT_RENT_A_CAR: 'Replacement Rent A Car',
  RESERVE_RENT_A_CAR: 'Reserve Rent A Car',
  RESIDENCE_INN: 'Residence Inn',
  RESO_HOTELS: 'Reso Hotels',
  RICA_HOTELS: 'Rica Hotels',
  RIO_HOTELS: 'Rio Hotels',
  RIO_SUITES: 'Rio Suites',
  RITZ_CARLTON: 'Ritz Carlton',
  RIVERSIDE_RESORT_AND_CASINO: 'Riverside Resort And Casino',
  RIVIERA_HOTEL_AND_CASINO: 'Riviera Hotel And Casino',
  RODEWAY_INNS_INTERNATIONAL: 'Rodeway Inns International',
  ROOFING_SIDING_SHEET_METAL: 'Roofing Siding Sheet Metal',
  ROSEN_HOTEL_AND_RESORTS: 'Rosen Hotel And Resorts',
  ROYAL_HOTELS: 'Royal Hotels',
  ROYAL_KONA_RESORT: 'Royal Kona Resort',
  ROYCE_HOTEL: 'Royce Hotel',
  RYANAIR: 'Ryanair',
  SABENA: 'Sabena',
  SADDLEBROOK_RESORT_TAMPA: 'Saddlebrook Resort Tampa',
  SAETA_AIR: 'Saeta Air',
  SAHARA_HOTEL_AND_CASINO: 'Sahara Hotel And Casino',
  SAHSA_AIR: 'Sahsa Air',
  SAMS_TOWN_HOTEL_AND_CASINO: 'Sams Town Hotel And Casino',
  SANDMAN_HOTELS: 'Sandman Hotels',
  SANDMAN_INN: 'Sandman Inn',
  SANDS_RESORT: 'Sands Resort',
  SAN_JUAN_AIR: 'San Juan Air',
  SARA_HOTELS: 'Sara Hotels',
  SAROVA_HOTELS: 'Sarova Hotels',
  SAUDIA_ARABIAN_AIRLINES: 'Saudia Arabian Airlines',
  SCANDIC_HOTELS: 'Scandic Hotels',
  SCANDINAVIAN_AIRLINE_SYSTEM: 'Scandinavian Airline System',
  SCENIC_AIRLINES: 'Scenic Airlines',
  SEA_PINES_RESORT: 'Sea Pines Resort',
  SECRETARIAL_SUPPORT_SERVICES: 'Secretarial Support Services',
  SECURITY_BROKERS_DEALERS: 'Security Brokers Dealers',
  SERVICE_STATIONS: 'Service Stations',
  SETTLE_INN: 'Settle Inn',
  SEWING_NEEDLEWORK_FABRIC_AND_PIECE_GOODS_STORES: 'Sewing Needlework Fabric And Piece Goods Stores',
  SHANGRI_LA_INTERNATIONAL: 'Shangri La International',
  SHERATON: 'Sheraton',
  SHILO_INN: 'Shilo Inn',
  SHOE_REPAIR_HAT_CLEANING: 'Shoe Repair Hat Cleaning',
  SHOE_STORES: 'Shoe Stores',
  SHONEYS_INN: 'Shoneys Inn',
  SHOWCASE_RENTAL_CARS: 'Showcase Rental Cars',
  SILVER_LEGACY_HOTEL_AND_CASINO: 'Silver Legacy Hotel And Casino',
  SILVER_STAR_HOTEL_AND_CASINO: 'Silver Star Hotel And Casino',
  SIMMONS_AIRLINES: 'Simmons Airlines',
  SINGAPORE_AIRLINES: 'Singapore Airlines',
  SINGLETON_AIR: 'Singleton Air',
  SIXT_CAR_RENTAL: 'Sixt Car Rental',
  SKYWAYS_AIR: 'Skyways Air',
  SLEEP_INN: 'Sleep Inn',
  SMALL_APPLIANCE_REPAIR: 'Small Appliance Repair',
  SMUGGLERS_NOTCH_RESORT: 'Smugglers Notch Resort',
  SNAPPY_CAR_RENTAL: 'Snappy Car Rental',
  SNOWMOBILE_DEALERS: 'Snowmobile Dealers',
  SOFITEL_HOTELS: 'Sofitel Hotels',
  SOHO_GRAND_HOTEL: 'Soho Grand Hotel',
  SOKOS_HOTEL: 'Sokos Hotel',
  SOL_HOTELS: 'Sol Hotels',
  SONESTA_INTERNATIONAL_HOTELS: 'Sonesta International Hotels',
  SOUTHERN_PACIFIC_HOTEL: 'Southern Pacific Hotel',
  SOUTHERN_SUN_HOTELS: 'Southern Sun Hotels',
  SOUTHWEST_AIRLINES: 'Southwest Airlines',
  SOUTH_AFRICAN_AIRWAYS: 'South African Airways',
  SPANAIR: 'Spanair',
  SPECIALTY_CLEANING: 'Specialty Cleaning',
  SPECIAL_TRADE_SERVICES: 'Special Trade Services',
  SPIRIT_AIRLINES: 'Spirit Airlines',
  SPORTING_GOODS_STORES: 'Sporting Goods Stores',
  SPORTING_RECREATION_CAMPS: 'Sporting Recreation Camps',
  SPORTS_AND_RIDING_APPAREL_STORES: 'Sports And Riding Apparel Stores',
  SPORTS_CLUBS_FIELDS: 'Sports Clubs Fields',
  SPRINGHILL_SUITES: 'Springhill Suites',
  STAKIS_HOTELS: 'Stakis Hotels',
  STAMP_AND_COIN_STORES: 'Stamp And Coin Stores',
  STATIONARY_OFFICE_SUPPLIES_PRINTING_AND_WRITING_PAPER:
    'Stationary Office Supplies Printing And Writing Paper',
  STATIONERY_STORES_OFFICE_AND_SCHOOL_SUPPLY_STORES: 'Stationery Stores Office And School Supply Stores',
  STAYBRIDGE_SUITES: 'Staybridge Suites',
  STEIGENBERGER: 'Steigenberger',
  STRATOSPHERE_HOTEL_AND_CASINO: 'Stratosphere Hotel And Casino',
  STUDIO_PLUS: 'Studio Plus',
  ST_REGIS_HOTEL: 'St Regis Hotel',
  SUDAN_AIRWAYS: 'Sudan Airways',
  SUISSE_CHALET: 'Suisse Chalet',
  SUMMERFIELD_SUITES_HOTEL: 'Summerfield Suites Hotel',
  SUNBELT_AIRLINES: 'Sunbelt Airlines',
  SUNWORLD_AIR: 'Sunworld Air',
  SUN_COUNTRY_AIRLINES: 'Sun Country Airlines',
  SUPER_8_MOTEL: 'Super 8 Motel',
  SURINAM_AIRWAYS: 'Surinam Airways',
  SWALLOW_HOTELS: 'Swallow Hotels',
  SWIMMING_POOLS_SALES: 'Swimming Pools Sales',
  SWISSOTEL: 'Swissotel',
  SWISS_AIR: 'Swiss Air',
  TACA_INTERNATIONAL_AIR: 'Taca International Air',
  TAILORS_ALTERATIONS: 'Tailors Alterations',
  TAJ_HOTELS_INTL: 'Taj Hotels Intl',
  TAL_AIR: 'Tal Air',
  TAME_AIR: 'Tame Air',
  TAM_AIRLINES: 'Tam Airlines',
  TAN_AIR: 'Tan Air',
  TAP_AIR_PORTUGAL: 'Tap Air Portugal',
  TAROM_AIR: 'Tarom Air',
  TAXICABS_LIMOUSINES: 'Taxicabs Limousines',
  TAX_PAYMENTS_GOVERNMENT_AGENCIES: 'Tax Payments Government Agencies',
  TAX_PREPARATION_SERVICES: 'Tax Preparation Services',
  TELECOMMUNICATION_EQUIPMENT_AND_TELEPHONE_SALES: 'Telecommunication Equipment And Telephone Sales',
  TELECOMMUNICATION_SERVICES: 'Telecommunication Services',
  TELEGRAPH_SERVICES: 'Telegraph Services',
  TENT_AND_AWNING_SHOPS: 'Tent And Awning Shops',
  TESTING_LABORATORIES: 'Testing Laboratories',
  THAI_AIRWAYS: 'Thai Airways',
  THEATRICAL_TICKET_AGENCIES: 'Theatrical Ticket Agencies',
  THE_ATLANTIC: 'The Atlantic',
  THE_DIPLOMAT_COUNTRY_CLUB_AND_SPA: 'The Diplomat Country Club And Spa',
  THE_ELIOT_HOTEL: 'The Eliot Hotel',
  THE_FLAMINGO_HOTELS: 'The Flamingo Hotels',
  THE_PALACE_HOTEL: 'The Palace Hotel',
  THE_PHOENICIAN: 'The Phoenician',
  THE_ROOSEVELT_HOTEL_NY: 'The Roosevelt Hotel Ny',
  THE_WIGWAM_GOLF_RESORT_AND_SPA: 'The Wigwam Golf Resort And Spa',
  THRIFTY_CAR_RENTAL: 'Thrifty Car Rental',
  THUNDERBIRD_RED_LION: 'Thunderbird Red Lion',
  THY_AIRLINE: 'Thy Airline',
  TIGERAIR: 'Tigerair',
  TILDEN_RENT_A_CAR: 'Tilden Rent A Car',
  TIMESHARES: 'Timeshares',
  TIRE_RETREADING_AND_REPAIR: 'Tire Retreading And Repair',
  TOKYO_GROUP: 'Tokyo Group',
  TOLLS_BRIDGE_FEES: 'Tolls Bridge Fees',
  TOURIST_ATTRACTIONS_AND_EXHIBITS: 'Tourist Attractions And Exhibits',
  TOWER_AIR: 'Tower Air',
  TOWING_SERVICES: 'Towing Services',
  TOWNEPLACE_SUITES: 'Towneplace Suites',
  TOWN_AND_COUNTRY_RESORT_AND_CONVENTION_CENTER: 'Town And Country Resort And Convention Center',
  TRADEWINDS_RESORT: 'Tradewinds Resort',
  TRAILER_PARKS_CAMPGROUNDS: 'Trailer Parks Campgrounds',
  TRANSAERO: 'Transaero',
  TRANSPORTATION_SERVICES: 'Transportation Services',
  TRANS_WORLD_AIRLINES: 'Trans World Airlines',
  TRAVELODGE_MOTELS: 'Travelodge Motels',
  TRAVEL_AGENCIES_TOUR_OPERATORS: 'Travel Agencies Tour Operators',
  TREASURE_ISLAND_HOTEL_AND_CASINO: 'Treasure Island Hotel And Casino',
  TRIANGLE_RENT_A_CAR: 'Triangle Rent A Car',
  TRIBECA_GRAND_HOTEL: 'Tribeca Grand Hotel',
  TROPICAL_RENT_A_CAR: 'Tropical Rent A Car',
  TROPICANA_RESORT_AND_CASINO: 'Tropicana Resort And Casino',
  TRUCK_STOP_ITERATION: 'Truck Stop Iteration',
  TRUCK_UTILITY_TRAILER_RENTALS: 'Truck Utility Trailer Rentals',
  TRUSTHOUSE_FORTE: 'Trusthouse Forte',
  TUNIS_AIR: 'Tunis Air',
  TYPESETTING_PLATE_MAKING_AND_RELATED_SERVICES: 'Typesetting Plate Making And Related Services',
  TYPEWRITER_STORES: 'Typewriter Stores',
  T_UI_TRAVEL_GERMANY: 'T Ui Travel Germany',
  UGLY_DUCKLING_RENT_A_CAR: 'Ugly Duckling Rent A Car',
  UNIFORMS_COMMERCIAL_CLOTHING: 'Uniforms Commercial Clothing',
  UNITED_AIRLINES: 'United Airlines',
  UNI_AIRWAYS_CORPORATION: 'Uni Airways Corporation',
  USA_RENTAL: 'Usa Rental',
  USED_MERCHANDISE_AND_SECONDHAND_STORES: 'Used Merchandise And Secondhand Stores',
  US_AIRWAYS: 'Us Airways',
  US_AIR_SHUTTLE: 'Us Air Shuttle',
  US_FEDERAL_GOVERNMENT_AGENCIES_OR_DEPARTMENTS: 'Us Federal Government Agencies Or Departments',
  UTA_INTERAIR: 'Uta Interair',
  UTILITIES: 'Utilities',
  VAGABOND_HOTELS: 'Vagabond Hotels',
  VALLEY_AIRLINES: 'Valley Airlines',
  VALUE_RENT_A_CAR: 'Value Rent A Car',
  VANGUARD_AIR: 'Vanguard Air',
  VARIETY_STORES: 'Variety Stores',
  VARIG: 'Varig',
  VASP_AIR: 'Vasp Air',
  VDARA: 'Vdara',
  VENETIAN_RESORT_HOTEL_AND_CASINO: 'Venetian Resort Hotel And Casino',
  VENTURE_INN: 'Venture Inn',
  VETERINARY_SERVICES: 'Veterinary Services',
  VIASA_AIR: 'Viasa Air',
  VIDEO_AMUSEMENT_GAME_SUPPLIES: 'Video Amusement Game Supplies',
  VIDEO_GAME_ARCADES: 'Video Game Arcades',
  VIDEO_TAPE_RENTAL_STORES: 'Video Tape Rental Stores',
  VIRGIN_AMERICA: 'Virgin America',
  VIRGIN_ATLANTIC: 'Virgin Atlantic',
  VIRGIN_EXPRESS_AIR: 'Virgin Express Air',
  VIRGIN_RIVER_HOTEL_AND_CASINO: 'Virgin River Hotel And Casino',
  VLM_AIRLINES: 'Vlm Airlines',
  VOCATIONAL_TRADE_SCHOOLS: 'Vocational Trade Schools',
  WALDORF: 'Waldorf',
  WATCH_JEWELRY_REPAIR: 'Watch Jewelry Repair',
  WELCOMGROUP: 'Welcomgroup',
  WELDING_REPAIR: 'Welding Repair',
  WELLESLEY_INNS: 'Wellesley Inns',
  WESTIN_HOTELS: 'Westin Hotels',
  WESTJET_AIRLINES: 'Westjet Airlines',
  WHISKEY_PETES_HOTEL_AND_CASINO: 'Whiskey Petes Hotel And Casino',
  WHOLESALE: 'Wholesale',
  WHOLESALE_CLUBS: 'Wholesale Clubs',
  WIDEROES: 'Wideroes',
  WIG_AND_TOUPEE_STORES: 'Wig And Toupee Stores',
  WILDERNESS_HOTEL_AND_RESORT: 'Wilderness Hotel And Resort',
  WINDWARD_ISLAND_AIR: 'Windward Island Air',
  WINE_PRODUCERS: 'Wine Producers',
  WINGS_AIRWAYS: 'Wings Airways',
  WIRES_MONEY_ORDERS: 'Wires Money Orders',
  WIZZ_AIR: 'Wizz Air',
  WOMENS_ACCESSORY_AND_SPECIALTY_SHOPS: 'Womens Accessory And Specialty Shops',
  WOMENS_READY_TO_WEAR_STORES: 'Womens Ready To Wear Stores',
  WOODSIDE_HOTELS_AND_RESORTS: 'Woodside Hotels And Resorts',
  WRECKING_AND_SALVAGE_YARDS: 'Wrecking And Salvage Yards',
  WYNDHAM: 'Wyndham',
  WYNN_LAS_VEGAS: 'Wynn Las Vegas',
  W_HOTELS: 'W Hotels',
  ZAMBIA_AIRWAYS: 'Zambia Airways',
  AIR_TRANSAT: 'Air Transat',
  JHAT: 'JHAT',
  CEST_LA_VIE_RESORT_IZUMIGO: "C'est La Vie Resort Izumigo",
  BANYAN_TREE_HOTELS_AND_RESORTS: 'Banyan Tree Hotels and Resorts',
  HOTEL_SUNROUTE: 'Hotel Sunroute',
  SOTETSU_FRESA_INN: 'Sotetsu Fresa-Inn',
  LA_VISTA: 'La Vista',
  JR_EAST_HOTEL_METS: 'JR-East Hotel Mets',
  AB_HOTEL: 'AB Hotel',
  CHISUN_HOTELS: 'Chisun Hotels',
  SUPER_HOTEL: 'Super Hotel',
  ITOEN_HOTEL: 'Itoen Hotel',
  QUINTESSA_HOTEL: 'Quintessa Hotel',
  SMILE_HOTEL: 'Smile Hotel',
  HOTEL_ALPHA_1: 'Hotel Alpha-1',
  RELO_VACATIONS: 'Relo Vacations',
  YUTORELO: 'Yutorelo',
  KEIO_PRESSO_INN: 'Keio Presso Inn',
  VILLA_FONTAINE: 'Villa-Fontaine',
  MEITETSU_INN: 'Meitetsu Inn',
  TOKYU_HARVESTCLUB: 'Tokyu Harvest Club',
  HOTEL_LIVEMAX: 'Hotel Livemax',
  FUFU_JAPAN: 'Fufu Japan',
  HMI_HOTEL_GROUP: 'HMI Hotel Group',
  ORIX_HOTELS_AND_RESORTS: 'Orix Hotels and Resorts',
  WASHINGTON_HOTEL: 'Washington Hotel',
  SANCO_INN: 'Sanco Inn',
  HOTEL_UNIZO: 'Hotel Unizo',
  HOTEL_METROPOLITAN: 'Hotel Metropolitan',
  CENTURION_HOTELS: 'Centurion Hotels',
  NEST_HOTEL: 'Nest Hotel',
};
